import { Tabs } from '@seiue/ui'
import React from 'react'

import { Item } from './Item'
import { getBasicData } from './basicData'
import { getTemplateData } from './templateData'
import { FormulateDataType, FormulateType } from './types'
import { getBasicItemTypes, getTemplateTypes } from './utils'

const TabPaneContent: React.FC<{
  types: FormulateType[]
  allData: FormulateDataType[]
  onItemClick: (val: string) => void
  value: string
}> = ({ types, allData, onItemClick, value }) => {
  const [subTabKey, setSubTabKey] = React.useState<string>(types[0].key)
  const currentItem = allData.find((a) => a.key === subTabKey)
  return (
    <Tabs
      activeKey={subTabKey}
      onChange={setSubTabKey}
      tabBarStyle={{ marginBottom: 0 }}
    >
      {types.map((type) => (
        <Tabs.TabPane
          tab={type.label}
          key={type.key}
        >
          <Item
            item={currentItem?.data || []}
            onItemClick={onItemClick}
            value={value}
          />
        </Tabs.TabPane>
      ))}
    </Tabs>
  )
}

export const SelectFormula: React.FC<{
  value: string
  onItemClick: (val: string) => void
}> = (props) => {
  const basicTypes = getBasicItemTypes()
  const templateTypes = getTemplateTypes()
  const basicData = getBasicData()
  const templateData = getTemplateData()
  return (
    <Tabs
      type="outline-button"
      size="small"
    >
      <Tabs.TabPane
        tab="快捷工具"
        key="basic"
      >
        <TabPaneContent
          types={basicTypes}
          allData={basicData}
          {...props}
        />
      </Tabs.TabPane>
      <Tabs.TabPane
        tab="公式模板"
        key="template"
      >
        <TabPaneContent
          types={templateTypes}
          allData={templateData}
          {...props}
        />
      </Tabs.TabPane>
    </Tabs>
  )
}
